import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToContact = () => {
  const location = useLocation();

  const scrollToContact = useCallback((e?: React.MouseEvent<HTMLAnchorElement>) => {
    if (e) {
      e.preventDefault();
    }
    
    // Wenn wir nicht auf der Startseite sind, navigiere zur Startseite mit Anker
    if (location.pathname !== '/') {
      window.location.href = '/#kontakt';
      return;
    }
    
    // Scroll zum Kontaktformular mit verbesserter Animation
    setTimeout(() => {
      const contactSection = document.getElementById('kontakt');
      if (contactSection) {
        const headerHeight = 64; // Header Höhe
        const extraSpace = 100; // Zusätzlicher Abstand für bessere Sicht
        const targetPosition = contactSection.offsetTop - headerHeight - extraSpace;
        
        // Smooth scroll mit easing-Funktion für bessere UX
        window.scrollTo({
          top: Math.max(0, targetPosition),
          behavior: 'smooth'
        });
        
        // Nach dem Scrolling das erste Eingabefeld fokussieren
        setTimeout(() => {
          const firstNameInput = document.getElementById('name');
          if (firstNameInput) {
            firstNameInput.focus();
            
            // Für mobile Geräte: Zusätzliche Behandlung für bessere UX
            if (window.innerWidth <= 768) {
              // Warte etwas länger auf mobile für bessere Fokussierung
              setTimeout(() => {
                firstNameInput.focus();
                // Verhindere Zoom auf iOS bei Input-Focus
                firstNameInput.style.fontSize = '16px';
              }, 300);
            }
          }
        }, 800); // Warte bis Scroll-Animation fertig ist
      }
    }, 100);
  }, [location.pathname]);

  return scrollToContact;
}; 